/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/no-empty-interface */
export interface NotSupportedError extends Error { }

class NotSupportedErrorConstructor extends Error implements NotSupportedError {
  constructor(message?: string) {
    super(message ?? 'Not supported');
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

declare global {
  interface NotSupportedError extends Error { }
  interface NotSupportedErrorConstructor {
    new(message?: string): NotSupportedError;
    (message?: string): NotSupportedError;
    readonly prototype: NotSupportedError;
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const NotSupportedError: NotSupportedErrorConstructor;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const NotSupportedError = NotSupportedErrorConstructor;

export default NotSupportedError;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const windowLocal: any = window;
windowLocal.NotSupportedError = windowLocal.NotSupportedError || NotSupportedError;
